<template>
  <div class="amp_main">
    <div class="com_con" v-loading="loading">
      <div class="flex_bet_h tools_titmod">
        <span class="tools_tit">格式转换</span>
        <img src="../../assets/images/img2/offlogin.png" class="tools_off" @click="hide" />
      </div>
      <div class="tools_upfile" @click="show_list = true" style="height:72px">
        <div v-if="wodk_url == ''">
          <img src="../../assets/images/img2/addfile.png" class="tools_addfile" />
          <p>添加音频</p>
        </div>
        <div v-else>
          <p class="amp_url overflow_hide">{{ wodk_url }}</p>
          <p>已选择</p>
        </div>
      </div>
      <p style="font-size:16px">格式选择</p>
      <div class="format">
        <div class="format_li flex_cen" :class="format_sel===item?'format_li_act':''" v-for="(item,index) in format_list" :key="index" @click="format_sel=item">{{item.toUpperCase()}}</div>
      </div>
      <div class="format_ext flex_cen" @click="extend_Audio">
        <img src="../../assets/images/img2/exfile.png" class="tools_btn_icon" />
        <span>导出音频</span>
      </div>
    </div>
    <audioLiist v-if="show_list" @hide="show_list = false" @setWork="setWork" />
  </div>
</template>
<script>
// 作品选择组件
import audioLiist from "./audio_list.vue";
export default ({
  components: {
    audioLiist,
  },
  data() {
    return {
      audio: new Audio(), //播放器
      loading: false, //加载动画状态
      show_list: false,//作品选择组件显示状态
      wodk_url: '',// 选择的音频地址
      format_list: ['wav', 'aac', 'm4a', 'wma', 'amr', 'flac'],//格式转换列表
      format_sel: 'wav',//当前选择的转换格式
    }
  },
  methods: {
    // 导出作品
    extend_Audio() {
      if (this.wodk_url == "") {
        this.$message({
          message: "请选择需要修改的音频",
          type: "warning",
        });
        return;
      }
      this.loading = true;
      let url = this.$store.state.app_api + this.$store.state.app_url.convertAudioFormat;
      let json = {
        url: this.wodk_url,
        audioFormat: this.format_sel
      };
      this.$request.postHttp(json, url, (response) => {
        this.loading = false
        console.log(333,response)
        let mp3url = response.model.url;
        if (!mp3url) {
          this.$message.error("操作失败！");
        }
        this.$globalFun.downloadDub(mp3url);
      })
    },
    // 关闭点击
    hide() {
      this.$emit("hide");
    },
    // 选择作品
    setWork(e) {
      this.show_list = false
      this.wodk_url = e.musicpath
    }
  }
})
</script>
<style>
@import url("../../assets/css/tools.css");
</style>



// WEBPACK FOOTER //
// src/components/tools/audio_format.vue